import { FaGithub, FaLocationArrow, FaFacebook, FaLinkedin, FaInstagram, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

const Contact = () => {
    const [input, setInput] = useState({
        user_name: '',
        subject: '',
        user_email: '',
        message: ''
    });

    const handleChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const email = emailjs.send('service_8gaafxd', 'template_klaqxf5', input, { publicKey: 'JfnwT4cC8qSIZwDE_' })
            if (email) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Message Has been sent",
                    showConfirmButton: false,
                    timer: 1500
                });
                setInput({
                    user_name: '',
                    subject: '',
                    user_email: '',
                    message: ''
                });
            }
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Failed to send message !",
                showConfirmButton: false,
                timer: 1500
            });
        }
    }

    return (
        <div id="contact">
            <div className="form-container">
                <span className="big-circle"></span>
                <img src="img/shape.png" className="square" alt="" />
                <div className="form">
                    <div className="contact-info">
                        <h3 className="title">Let's get in touch</h3>
                        <p className="text">
                            Reach out to me directly for inquiries, collaborations, or any questions you may have. I'm here to assist you!
                        </p>
                        <div className="info">
                            <div className="information d-flex justify-content-start align-items-center">
                                <FaLocationArrow className='info-icon' />
                                <p className='mb-0 ms-2'>Moulvibazar, Bangladesh</p>
                            </div>
                            <div className="information">
                                <FaEnvelope className='info-icon' />
                                <p className='mb-0 ms-2'><a href="mailto:ujjalzaman@gmail.com" style={{ textDecoration: 'none', color: 'inherit' }}>ujjalzaman@gmail.com</a></p>
                            </div>
                            <div className="information">
                                <FaPhoneAlt className='info-icon' />
                                <p className='mb-0 ms-2'><a href="tel:+8801751040425" style={{ textDecoration: 'none', color: 'inherit' }}>+8801751040425</a></p>
                            </div>
                        </div>
                        <div className="social-media">
                            <p>Connect with us :</p>
                            <div className="social-icons">
                                <a href="www.linkedin.com/in/ujjal-zaman" target='_blank'>
                                    <FaLinkedin className='icon' />
                                </a>
                                <a href="https://github.com/Ujjalzaman" target='_blank'>
                                    <FaGithub className='icon' />
                                </a>
                                <a href="https://web.facebook.com/ujjal.zaman" target='_blank'>
                                    <FaFacebook className='icon' />
                                </a>
                                <a href="https://www.instagram.com/ujjal_zaman/" target='_blank'>
                                    <FaInstagram className='icon' />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form">
                        <span className="circle one"></span>
                        <span className="circle two"></span>

                        <form onSubmit={handleSubmit}>
                            <h3 className="title">Contact us</h3>
                            <div className="input-container">
                                <input required type="text" value={input.user_name} placeholder='Username' name="user_name" className="input" onChange={(e) => handleChange(e)} />
                            </div>
                            <div className="input-container">
                                <input required type="text" placeholder='Subject' value={input.subject} name="subject" className="input" onChange={(e) => handleChange(e)} />
                            </div>
                            <div className="input-container">
                                <input required type="email" placeholder='example@mail.com' value={input.user_email} name="user_email" className="input" onChange={(e) => handleChange(e)} />
                            </div>
                            <div className="input-container textarea">
                                <textarea required name="message" placeholder='Your Message' value={input.message} className="input" onChange={(e) => handleChange(e)}></textarea>
                            </div>
                            <input type="submit" value="Send" className="btn" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;